import "../../../scss/delete-confirm-modal.scss";
import React from "react";

type DeleteConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deleteType: "permanent" | "trash";
};

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  deleteType,
}) => {
  if (!isOpen) return null;

  const title =
    deleteType === "permanent" ? "Delete Permanently?" : "Move to Trash?";
  const description =
    deleteType === "permanent"
      ? "This action cannot be undone. The product will be permanently deleted."
      : "This product will be moved to trash.";
  const confirmLabel =
    deleteType === "permanent" ? "Delete Permanently" : "Move to Trash";

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{title}</h3>
        <p>{description}</p>
        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-confirm" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
